import React, { useContext } from "react";
import { Td, Tr, Button, Box } from "@chakra-ui/react";
import { BsEyeFill } from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";
import { IconGeneric } from "styled/Icons.styled";
import DianCRUDContext from "context/DianCrudContext";
import { __PostForm } from "request/Petitions/__Post";
import environment from "constants/apiConst";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";

const TbodyProfile = ({ data, iope }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const [openAlert] = AlertErrorAlert();
  const navigate = useNavigate();

  const { setDataFormItems, setUpdate, setLoading, update, loading } =
    useContext(DianCRUDContext);

  const handleItems = () => {
    navigate(`/PerfilarItemsDocument?IdForm=${data?.form_id}&DocumentType=${data?.document_type}&QualifiedUserName=${data?.qualified_user_name}&FormCode=${data?.form_code}`);
    setDataFormItems(data);
  };

  const handleChange = async (label) => {
    const dataUpdateDocument = new FormData();
    dataUpdateDocument.append("document_type", data?.document_type);
    dataUpdateDocument.append("form_code", data?.form_code);
    dataUpdateDocument.append("dial_type", label);
    setLoading(true);
    try {
      const res = await __PostForm(
        environment.DOCUMENTS_PROFILES_UPDATE,
        token,
        dataUpdateDocument
      );
      if (res?.data?.status?.code === 200) {
        setUpdate(!update);
      } else {
        openAlert(res.data.status.message, "error");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const urlForm = {
    "FORM.SALID": `/FormShowExit?ExitNumber=${data?.form_id}`,
    "FORM.INGR.": `/FormShow?FormEntry=${data?.form_id}`,
    "default": `/FormShow?FormEntry=${data?.form_id}`,
  }[data?.document_type || "default"];

  return (
    <>
      <Tr className={"verticalNone"}>
        <Td className="text-center">{data?.date}</Td>
        <Td className="text-center">{data?.document_type}</Td>

        <Td className="text-center">
          <NavLink
            to={urlForm}
            className="ms-2"
          >
            <span className="formNumber">{data?.form_code}</span>
          </NavLink>
        </Td>
        {/* <Td className="text-center" onClick={handleInfoForm}>
          <span className="formNumber">{data?.form_code}</span>
        </Td> */}
        <Td className="text-center">{data?.qualified_user_name}</Td>
        <Td className="text-center">{data?.operation_code}</Td>
        <Td className="text-center">{data?.num_transport_document}</Td>
        <Td className="text-center">{ }</Td>
        <Td className="text-center">{ }</Td>

        <Td className="text-center">{data?.quantity_pass_item}</Td>
        <Td className="text-center">
          <IconGeneric
            color={"#1F7AC3"}
            as={BsEyeFill}
            onClick={() => handleItems()}
          />
        </Td>

        <Td
          style={{
            width: "17%",
            paddingLeft: "13px"
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={{ base: "10px", md: "8px" }}
            width="100%"
            marginBottom="20px"
          >
            <Button
              onClick={() => handleChange("Si")}
              bg={data?.dial_type === "Si" ? "#dc3545" : "#dc354580"}
              color="white"
              _hover={{
                bg: data?.dial_type === "Si" ? "#c82333" : "#dc3545"
              }}
              _active={{
                bg: "#c82333"
              }}
              fontSize={{ base: "16px", sm: "15px", md: "16px" }}
              minH={{ base: "50px", sm: "48px", md: "44px" }}
              px={{ base: "20px", sm: "18px", md: "20px" }}
              fontWeight="600"
              borderRadius="6px"
              border={data?.dial_type === "Si" ? "2px solid #c82333" : "2px solid #dc3545"}
              boxShadow={data?.dial_type === "Si" ? "0 2px 4px rgba(220, 53, 69, 0.3)" : "none"}
              transition="all 0.2s"
              isLoading={loading}
              disabled={loading}
              width="100%"
              cursor={loading ? "not-allowed" : "pointer"}
            >
              Si
            </Button>
            <Button
              onClick={() => handleChange("No")}
              bg={data?.dial_type === "No" ? "#28a745" : "#28a74580"}
              color="white"
              _hover={{
                bg: data?.dial_type === "No" ? "#218838" : "#28a745"
              }}
              _active={{
                bg: "#218838"
              }}
              fontSize={{ base: "16px", sm: "15px", md: "16px" }}
              minH={{ base: "50px", sm: "48px", md: "44px" }}
              px={{ base: "20px", sm: "18px", md: "20px" }}
              fontWeight="600"
              borderRadius="6px"
              border={data?.dial_type === "No" ? "2px solid #218838" : "2px solid #28a745"}
              boxShadow={data?.dial_type === "No" ? "0 2px 4px rgba(40, 167, 69, 0.3)" : "none"}
              transition="all 0.2s"
              isLoading={loading}
              disabled={loading}
              width="100%"
              cursor={loading ? "not-allowed" : "pointer"}
            >
              No
            </Button>
          </Box>
        </Td>
      </Tr>
    </>
  );
};

export default TbodyProfile;
